'use client';

import { useEffect } from 'react';

export const ScrollRestoration = () => {
  useEffect(() => {
    let dom: HTMLElement | null;
    let top: boolean;
    if (location.hash) {
      window.scrollTo({ behavior: 'smooth', top: 0.5 });
    } else {
      window.history.scrollRestoration = 'manual';
    }
    const scroll = () => {
      if (!dom && location.hash) {
        dom = document.getElementById(location.hash.substring(1));
      }
      if (dom && !top) {
        top = true;
        dom.scrollIntoView();
        window.removeEventListener('scroll', scroll);
      }
    };
    window.addEventListener('scroll', scroll);
    return () => window.removeEventListener('scroll', scroll);
  }, []);
  return null;
};

export const NextScrollRestoration = () => {
  useEffect(() => {
      if (location.hash) {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        window.history.scrollRestoration = 'auto';
      }
  }, []);
  return null;
}

export const NextScrollNormalRestoration = () => {
  useEffect(() => {
     window.history.scrollRestoration = 'manual';
  }, []);
  return null;
}
